import moment from 'moment';
import { periodOptions } from '@/features/osago-calculator/config';

export default {
  methods: {
    getContractOsagoPeriodNameById(periodId) {
      return periodOptions.find(option => option.id === periodId)?.name || null;
    },
    getContractEndDate(startDate, periodId) {
      if (!startDate || !periodId) return null;

      const parsed = moment(startDate, ['DD.MM.YYYY', 'YYYY-MM-DD']);
      if (!parsed.isValid()) return null;

      let amount, unit;
      const str = String(periodId);

      if (/^\d+m$/i.test(str)) {
        amount = parseInt(str, 10);
        unit = 'months';
      } else if (/^\d+d$/i.test(str)) {
        amount = parseInt(str, 10);
        unit = 'days';
      } else {
        const n = Number(periodId);
        amount = n;
        unit = n <= 12 ? 'months' : 'days';
      }

      parsed.add(amount, unit).subtract(1, 'days');

      return parsed.format('DD.MM.YYYY');
    },
  },
};
